import { render, staticRenderFns } from "./ISwiper.vue?vue&type=template&id=36d6af97&scoped=true&"
import script from "./ISwiper.vue?vue&type=script&lang=js&"
export * from "./ISwiper.vue?vue&type=script&lang=js&"
import style0 from "./ISwiper.vue?vue&type=style&index=0&id=36d6af97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d6af97",
  null
  
)

export default component.exports